import React from 'react';
import * as action from '../Actions';
import Service from '../../service/Service';
const service = new Service();

export default function ({ catg, eleRef }) {
    console.log("eleRefeleRefeleRef===",eleRef.props.location.pathname)

    let ListTemplate;     
        ListTemplate = catg.subcategory && catg.subcategory.map((subcat, index) =>{
            const imgUrl = subcat.imgUrl && subcat.imgUrl.endsWith(".jpg") 
            ? subcat.imgUrl.replace(".jpg", ".webp") 
            : subcat.imgUrl;
            return(
                <li key={index} className="subcatg">
                    <button
                        type="button"
                        className="subcatg-button"
                        aria-label={`View details for ${subcat.categoryName}`}
                        onClick={() =>
                            action.gotoCatDetail(
                                service.replaceSymbols(subcat.categoryName),
                                subcat.isSubCatData
                            )
                        }
                    >
                    <div className="coloring-img">
                        {imgUrl ?
                            <img src={imgUrl} onError={(e) => { e.target.src = '/media/default-placeholder.png'; }} alt={subcat.categoryName} title={subcat.categoryName} className="dev_cat_img"/>
                            :
                            <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'} alt={subcat.categoryName} title={subcat.categoryName} className="dev_cat_img"/>
                        }
                    </div>
                    <div className="img-name">
                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Coloring-Bottom-Design.png'} alt=''></img>
                        {/* <svg viewBox="0 0 40 10">
                            <path d="M0 0 V 11 H 40 V 11 L 40 -2 Q 20 5, 0 0"></path>
                            <path d="M0 0 V 11 H 40 V 10 L 40 0 Q 20 5, 0 0"></path>
                        </svg> */}
                        <div className="dev_cat_nm">{subcat.categoryName}</div>
                    </div>
                    </button>
                </li>

            )
        }
          );
      

    return (
        <ul className="subcategory-list">
            {ListTemplate}
        </ul>
    )
}
